/**
 * Transforme le HTML en plain text
 */
export function txtStrip(html): string {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\n/g, '');
}